import request from '@/utils/request'

export default {
    // 添加错误日志
    upload (params) {
        return request.post('/base/logs/jsErrorUpload', params)
    }
}



// WEBPACK FOOTER //
// ./src/api/errorUpload.js